import { render, staticRenderFns } from "./WizardClientStep.vue?vue&type=template&id=20976082&"
import script from "./WizardClientStep.vue?vue&type=script&lang=js&"
export * from "./WizardClientStep.vue?vue&type=script&lang=js&"
import style0 from "./wizard-step-shared.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports